/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
import EDC from './globals';
import { Menu } from './menu';

/**
 *
 */
EDC.UI.MainMenu = function () {
  Menu.apply(this, arguments);
  this.noKeyboard = true;
};
/**
 *
 */
EDC.UI.MainMenu.prototype = Object.create(Menu.prototype);
EDC.UI.MainMenu.prototype.constructor = EDC.UI.MainMenu;
/**
 *
 */
EDC.UI.MainMenu.prototype.create = function () {
  Menu.prototype.create.apply(this, arguments);
  this.bg.y += this.bg.height;
  this.isShowed = true;
  this.buttonsContainer.setVisible(true);
};

export default EDC.UI.MainMenu;
